import { render, staticRenderFns } from "./LoveCenter.vue?vue&type=template&id=491caf8e&scoped=true&"
import script from "./LoveCenter.vue?vue&type=script&lang=js&"
export * from "./LoveCenter.vue?vue&type=script&lang=js&"
import style0 from "./LoveCenter.vue?vue&type=style&index=0&lang=less&"
import style1 from "./LoveCenter.vue?vue&type=style&index=1&id=491caf8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491caf8e",
  null
  
)

export default component.exports